import { getExceptionHandler } from "@alfa-web-tools/requests-utils";
import { UseNavigateReturnType } from '@alfa-retail-react/components/navigate-hook';

import { NotFoundException } from 'app/api/exception/NotFoundException';
import {
    ERROR_PAGE_URL,
    ErrorPageState,
} from 'app/logic/pages/error/ErrorPage';

interface INotFoundExceptionHandlerData {
    navigate: UseNavigateReturnType;
    title?: string;
    messages?: string[];
    actionButtonText?: string;
    actionHandler?: () => void;
}

export const notFoundExceptionHandler = (
    {
        navigate,
        title,
        messages,
        actionButtonText,
        actionHandler,
    }: INotFoundExceptionHandlerData,
    callback?: () => void,
) => {
    return getExceptionHandler(
        NotFoundException.NAME,
        (exception: NotFoundException) => {
            callback?.();
            navigate<ErrorPageState>(ERROR_PAGE_URL, {
                title,
                actionButtonText,
                actionHandler,
                messages: messages || [exception.message],
            });
        },
    );
};
